import { clickedInsideElementBoundingRect } from "../utils/events";
import { TOP_LAYER_STACK } from "../top-layer/top-layer-stack";

export function initializeNavigation(): void {
	const dialog = document.getElementById("navigation-dialog") as HTMLDivElement;

	const mainMenuToggler = document.querySelector(".main-menu > .main-menu-toggler");
	if (mainMenuToggler !== null) {
		mainMenuToggler.addEventListener("click", () => {
			TOP_LAYER_STACK.openDialog(dialog, {
				keepInBodyWhenRemoving: true,
			});

			window.requestAnimationFrame(() => {
				(dialog.querySelector(".close-button")! as HTMLButtonElement).focus();
			});
		});
	}

	dialog.querySelector(".close-button")!.addEventListener("click", () => {
		TOP_LAYER_STACK.close(dialog);
	});

	dialog.addEventListener("click", (e) => {
		if (!clickedInsideElementBoundingRect(e, dialog)) {
			TOP_LAYER_STACK.close(dialog);
		}
	});

	const cookiesConfig = document.getElementById("cookies-config") as HTMLAnchorElement;

	cookiesConfig.addEventListener("click", (e) => {
		e.preventDefault();
		TOP_LAYER_STACK.close(dialog);
		Cookiebot.renew();
	});
}
